import React, { Component } from "react";
import {
	View,
	Text,
	StyleSheet,
	TextInput,
	Button,
	Platform,
	Image,
	TouchableOpacity,
	AsyncStorage,
	Animated,
	Dimensions,
	Easing,
	TouchableHighlight,
	AppState,
	Alert
} from "react-native";

import debounce from "lodash.debounce";
import isEqual from "lodash.isequal";
import { translate } from "react-i18next";

import SafeAreaView from "components/third-party/react-native-safe-area-view";

import AWS from "aws-sdk/dist/aws-sdk-react-native";
import AWSIoTData from "components/third-party/AWSIoTData";
import BackgroundImage from "components/BackgroundImage";
import {
	ControlPanelIP,
	ControlPanelPostIP,
	MODE,
	AWS as AWSConfig,
	AppURL,
} from "utils/config";
import { push, reset } from "utils/navigation";
import { Storage } from "utils/storage";
import { get, post } from "api";
import HomeCircle from "components/svgs/HomeCircle";
import StatusBar from "components/StatusBar";
import Auto from "components/svgs/Auto";
import ArrowUp from "components/svgs/ArrowUp";
import Cool from "components/svgs/Cool";
import SafetyWater from "components/svgs/SafetyWater";
import Exhaust from "components/svgs/Exhaust";
import PowerOff from "components/svgs/PowerOff";
import Signout from "components/svgs/Signout";
import Fan from "components/svgs/Fan";
import Gauge from "components/Gauge";
import HomeButton from "components/HomeButton";
import { signout, refresh, autoLogin } from "utils/awsAuth";
import User from "components/svgs/User";
import UnitDetail from "components/svgs/UnitDetail";
import DeviceSetting from "components/svgs/DeviceSetting";
import Timer from "components/svgs/Timer";
import Plus from "components/svgs/Plus";
import More from "components/svgs/More";
import Back from "components/svgs/Back";
import DialogInput from "components/Modal";
import WebView from "views/DeviceAuth/Webview";

import * as x from "../../styles/css";

const window = Dimensions.get('window');

class Home extends Component {
	static navigationOptions = {
		header: null,
	};

	static isPrivate = true;

	constructor(props) {
		super(props);

		this.state = {
			deviceId: null,
			friendlyName: null,
			deviceId1: null,
			friendlyName1: null,
			deviceId2: null,
			friendlyName2: null,
			prevColor: x.colors.gray,
			prevColorLight: x.colors.grayLight,
			prevColorDark: x.colors.grayDark,
			color: x.colors.gray,
			colorLight: x.colors.grayLight,
			colorDark: x.colors.grayDark,
			defaultColor: x.colors.primaryGlass,
			defaultColorLight: x.colors.primaryLight,
			defaultColorDark: x.colors.primaryDark,
			colorChange: new Animated.Value(0),
			modeText: props.t("labels.updating"),
			desired: {
				mvalue: 0,
				mode: 0,
			},
			appState: AppState.currentState,
			reported: {
				mode: MODE.OFF,
				mvalue: 0,
				mmin: 1,
				mmax: 100,
				version: 0,
				timerhour: 0,
				timermin: 0,
				online: 1,
			},
			width: Dimensions.get("window").width,
			height: Dimensions.get("window").height,
			connected: false,
			safetyWater: false,
			isDialogVisible: false,
			timerSet:false,
			timerTo: "off",
			moreButton:true,
			actionContainer: undefined,
			actionContainerOffset: new Animated.Value(0),
			showUnitDetail: false,
			shadowDetails: null
		};

		this.thingShadows = null;
		this.logout = this.logout.bind(this);
		this.incrementValue = this.incrementValue.bind(this);
		this.decrementValue = this.decrementValue.bind(this);
		this.changeMode = debounce(this.changeMode.bind(this), 1000);
		this.perform = debounce(this.perform.bind(this), 1000);
		this.timer = null;
		this.stopTimer = this.stopTimer.bind(this);
		this.registerDevice = this.registerDevice.bind(this);
		this.initDevice = this.initDevice.bind(this);
		this.handleLayout = this.handleLayout.bind(this);
		this.checkOffline = debounce(this.checkOffline.bind(this), 7000);
		this.goRegister = this.goRegister.bind(this);
		this.goUserDetail = this.goUserDetail.bind(this);
		this.goUnitDetail = this.goUnitDetail.bind(this);
		this.goDeviceSetting = this.goDeviceSetting.bind(this);
		this.goAddDevice = this.goAddDevice.bind(this);
		this.goMore = this.goMore.bind(this);
		this.goBack = this.goBack.bind(this);
		this.diff_seconds = this.diff_seconds.bind(this);
		this.touchMode = this.touchMode.bind(this);
		this.getModeValues = this.getModeValues.bind(this);
		this._foreignStateChange = debounce(this._foreignStateChange.bind(this), 1000);

		this._handleAppStateChange = this._handleAppStateChange.bind(this);

		this.toggleShowUnitDetail = this.toggleShowUnitDetail.bind(this);
	}

	componentDidMount() {
		if (this.debugCheck()) {console.log("Home - Component did mount")};
		this.setState({
			loading: true,
			width: Dimensions.get("window").width,
			height: Dimensions.get("window").height,
		});

		AppState.addEventListener("change", this._handleAppStateChange);
		this.initDevice();
	}

	componentWillUnmount() {
		if (this.thingShadows) {
			this.thingShadows.end();
		}

		AppState.removeEventListener("change", this._handleAppStateChange);
	}

	_handleAppStateChange(nextAppState) {
		if (this.state.appState.match(/inactive|background/)) {
			if (nextAppState === "active") {
				this.setState({
					loading: true,
				});
				this.initDevice();
			}
			if (nextAppState === "background") {
				if (this.thingShadows) {
					this.thingShadows.end();
				}
			}
		}
		this.setState({ appState: nextAppState });
	}

	diff_seconds(dt2, dt1) {
		var diff = (dt2.getTime() - dt1.getTime()) / 1000;
		return Math.round(diff);
	}

	debugCheck() {
		let debug = true;
		return debug;
	}

	checkOffline() {
		if (this.debugCheck()) {console.log("Checking if offline");}
		let offline = true;

		const body = {
			online: null,
		};
		post(`${ControlPanelPostIP}/${this.state.deviceId}`, body)
			.then(res => {
				var a = this.state.metadata.reported.online.timestamp;
				var b = this.state.metadata.desired.online.timestamp;
				if (a > b) {
					offline = false;
					if (this.debugCheck()) {console.log("Offline check passed - keypad online");}
				}
				if (this.debugCheck()) {console.log("Offline status :", offline);}
				if (offline === true) {
					if (this.debugCheck()) {console.log("Offline check - Setting status to offline");};
					this.setState({
						loading: false,
						connected: false,
						modeText: this.props.t("labels.offline"),
						color: x.colors.gray,
						colorLight: x.colors.grayLight,
						colorDark: x.colors.grayDark,
					});
					if (this.activityAni) {
						this.state.colorChange.setValue(0);};
					} else {
						const { modeText, color, colorLight, colorDark } = this.updateMode(
						this.state.reported.mode
						);

						this.setState({
							modeText,
							colorLight,
							color,
							colorDark,
							connected: true,
						});
				  }
			});
	}

	_foreignStateChange(thingName, operation, stateObject) {
		if (this.debugCheck()) {console.log("foreignStateChange ", thingName, stateObject)};
		clearTimeout(this.autoTimeout);

		// After the timer has been set and the keypad then goes into tiumer display mode.
		// This syncs the desired and reported mode to allow the display to latch over.
		if (stateObject.state.reported) {
			if (stateObject.state.reported.mode === 20  && this.state.desired.mode === 7) {
				if (this.debugCheck()) {console.log("foreignStateChange - stateObject reported 20 - setting desired mode to 20")}
				this.setState({
					timerSet: false,
					desired: {
						mode: 20,
					},
				})
			}
		}
		if (stateObject.state.reported) {
			if (stateObject.state.reported.mode){
				if (this.state.timerSet && stateObject.state.reported.mode === 7) {
					if (this.debugCheck()) {console.log("foreignStateChange - timerSet - ignoring incoming state change")};
					return;
				}
			}
		}
		if (!stateObject.state.reported) {
			if (this.debugCheck()) {console.log("foreignStateChange - Not stateObject.state.reported", stateObject)}
			/*
			this.setState({
				metadata: {
					...this.state.metadata,
					...stateObject.metadata,
				},
			});
			*/
			return;
		}
		if (stateObject.state.reported.mode === 6) {this.setState({safetyWater: true,});}

		if (stateObject.state.reported.mode) {
			if (this.debugCheck()) {console.log("stateObject.state.reported.mode - value : ",stateObject.state.reported.mode)};
			if (stateObject.state.reported.mode === 7 && this.state.desired.mode === 7){
				if (this.debugCheck()) {console.log("foreignStateChange - stateObject reported 7 - setting desired mode to 7")}
				this.setState({
					desired: {
						mode: 7,
					},
				})
				return;
			}
		}

		if (this.state.inc) {
			return;
		}

		if (stateObject.state.reported) {
			if (isEqual(this.state.reported, stateObject.state.reported)) {
				if (this.debugCheck()) {console.log("foreignStateChange - stateObject reported is equal to state.reported")}
				this.setState({
					loading: false
				});
				return;
			}
		}

		if (stateObject.state.reported) {
			const { t } = this.props;

			const {
				modeText,
				color,
				colorLight,
				colorDark,
				} = this.updateMode(
					stateObject.state.reported.mode
				);

			Animated.timing(this.state.colorChange, {
				toValue: 50,
				easing: Easing.linear,
				duration: 1000,
			}).start(ani => {
			if (ani.finished) {
				this.setState({
					prevColor: this.state.color,
					prevColorLight: this.state.colorLight,
					prevColorDark: this.state.colorDark,
				});
				this.state.colorChange.setValue(0);
				}
				});

			this.setState(
			{
				colorLight,
				color,
				colorDark,
				loading: true,
				loaded: true,
				metadata: {
					...this.state.metadata,
					...stateObject.metadata,
				},
				desired: {
					...this.state.desired,
					...stateObject.state.reported,
				},
				modeText: modeText
					? modeText
					: this.state.modeText,
			},
			() => {
				setTimeout(() => {
					this.setState({
						loading: false,
						reported: {
							...this.state.reported,
							...stateObject.state.reported,
						},
					});
				}, 500);
			}
		);
		if (this.debugCheck()) {console.log("Foreign State Change - End - this.state : ", this.state)}
	}
	}

	touchMode(mode) {
		if (this.debugCheck()) {console.log("touchMode Requested - mode requested : ", mode)}

		if (this.state.loading) {
			return;
		}

		// Switch from cool to pump and back
		if (mode === 3 && this.state.reported.mode === 3) {
			if (this.debugCheck()) {console.log("Cool button pressed in cool mode - changing from cool to pump")};

			if(Platform.OS !== "web") {
				Alert.alert(
					'',
					'Safety: Water Only Mode',
					[
					{text: 'OK', onPress: () => this.setState({safetyWater: true}) }
					],
					{ cancelable: true }
				)
			}else{
				alert('Safety - Water Only Mode');
				this.touchMode(MODE.PUMP);
				this.setState({safetyWater: true,});
			}
			return;
		}

		if (mode === 3 && this.state.reported.mode === 6) {
			if (this.debugCheck()) {console.log("Cool button pressed in pump mode - changing from pump to cool")};

			if(Platform.OS !== "web") {
				Alert.alert(
					'',
					'Safety water Only Mode',
					[
						{text: 'OK', onPress: () => this.setState({safetyWater: false}) }
					],
					{ cancelable: true }
				)
			}else{
				alert('Your are turning Safety Mode - Off');
				this.setState({
					safetyWater: false,
					desired: {
						mode: 3,
					},
				});
			}
		}// End Switch cool to pump

		if (mode === this.state.desired.mode) {
			return;
		}





		if (!this.state.timerSet && mode === 7) {
			if (this.debugCheck()) {console.log("Timer Set mode selected - Changing setState, reported, desired and timerSet to hold timer set mode for value.")};

			if (this.state.reported.mode === 0) {this.setState({timerTo: "on"});} else {this.setState({timerTo: "off"});};

			this.setState({
				timerSet: true,
				desired: {
					mode: 7,
					mvalue: 1,
					mmin: 1,
					mmax: 24,
				},
				reported: {
					mode: 7,
					mvalue: 1,
					mmin: 1,
					mmax: 24,
				},
				...this.getModeValues(MODE.TIMER_SET)},
				() => { if (this.debugCheck()) {console.log(this.state)};
			});
				return;
			} else {
				this.setState({
					desired: {
						...this.state.desired,
						mode,
						online: 1,
					},
					...this.getModeValues(MODE.UPDATING),
			});
		}

		this.changeMode(mode);
	}

	getModeValues(mode) {
		if (this.debugCheck()) {console.log("getModeValues - Switching Value : ", mode)}
		const { t } = this.props;
		const val = {};

		switch (mode) {
			case MODE.FAN:
				val.modeText = t("labels.fan");
				val.color = x.colors.fan;
				val.colorLight = x.colors.fan;
				val.colorDark = x.colors.fan;
				break;
			case MODE.COOL:
				val.modeText = t("labels.cool");
				val.color = x.colors.cool;
				val.colorLight = x.colors.cool;
				val.colorDark = x.colors.cool;
				break;
			case MODE.PUMP:
				val.modeText = t("labels.safetyWaterOnly");
				val.color = x.colors.safety;
				val.colorLight = x.colors.safety;
				val.colorDark = x.colors.safety;
				break;
			case MODE.AUTO:
				val.modeText = t("labels.auto");
				val.color = x.colors.auto;
				val.colorLight = x.colors.auto;
				val.colorDark = x.colors.auto;
				break;
			case MODE.AUTO_SET:
				val.modeText = t("labels.auto");
				val.color = x.colors.auto;
				val.colorLight = x.colors.auto;
				val.colorDark = x.colors.auto;
				break;
			case MODE.EXHAUST:
				val.modeText = t("labels.exhaust");
				val.color = x.colors.exhaust;
				val.colorLight = x.colors.exhaust;
				val.colorDark = x.colors.exhaust;
				break;
			case MODE.TIMER: {
				if (this.state.timerTo === "on"){
					val.modeText = t("labels.timerON");
					val.color = x.colors.blueGray;
					val.colorLight = x.colors.blueGrayLight;
					val.colorDark = x.colors.blueGrayDark;
					break;
				} else {
					val.modeText = t("labels.timerOFF");
					val.color = x.colors.blueGray;
					val.colorLight = x.colors.blueGrayLight;
					val.colorDark = x.colors.blueGrayDark;
					break;
				}
			}
			case MODE.TIMER_SET:
				val.modeText = t("labels.timer_set");
				val.color = x.colors.blueGray;
				val.colorLight = x.colors.blueGrayLight;
				val.colorDark = x.colors.blueGrayDark;
				break;
			case MODE.OFF:
				val.modeText = t("labels.room");
				val.color = x.colors.gray;
				val.colorLight = x.colors.grayLight;
				val.colorDark = x.colors.grayDark;
				break;
			case MODE.UPDATING:
				val.modeText = t("labels.updating");
				val.color = x.colors.gray;
				val.colorLight = x.colors.grayLight;
				val.colorDark = x.colors.grayDark;
				break;
			default:
				break;
		}
		if (this.debugCheck()) {console.log("getModeValues - switched result : ", val)}
		return val;
	}

	goRegister() {push({ mobile: "Connect", web: "/connect" }, this.props, true);}

	goUserDetail() {push({ mobile: "UserDetail", web: "/userdetail" }, this.props, true);}

	goDeviceSetting() {push({ mobile: "DeviceSetting", web: "/devicesetting" }, this.props, true);}

	goUnitDetail() {push({ mobile: "UnitDetail", web: "/unitdetail" }, this.props, true);}

	goAddDevice() {push({ mobile: "AddDevice", web: "/adddevice" }, this.props, true);}

	initDevice() {
		if (this.debugCheck()) {console.log("Initiating Device")}
		get(ControlPanelIP)
			.then(res => res.json())
			.then(async result => {
				if (result.devices.length < 1) {
					this.registerDevice();
				} else {
					if (this.debugCheck()) {console.log("Initiating Device - Result : ", result)};
					const storage = new Storage();
					const clientId = await storage.getItem("uuid");
					this.setState({
						deviceId: result.devices[0],
						clientId,
					});
					if (result.devices[1]) {
						this.setState({
							deviceId1: result.devices[1],
						});
					}
					if (result.devices[2]) {
						this.setState({
							deviceId2: result.devices[2],
						});
					}
					this.thingShadows = AWSIoTData.thingShadow({
						clientId, // use deviceid from cognito as clientid here
						region: AWSConfig.Region, // something like ap-southeast-2
						host: AWSConfig.Host, // something like a2e979oqcq3co8.iot.ap-southeast-2.amazonaws.com
						protocol: "wss",
						debug: false,
						accessKeyId: result.token.AccessKeyId,
						secretKey: result.token.SecretAccessKey,
						sessionToken: result.token.SessionToken,
					});

					this.thingShadows.on("connect", () => {
						if (this.debugCheck()) {console.log("Initiate Device - connect")};

						setTimeout(() => {
							const opClientToken = this.thingShadows.get(
								result.devices[0]
							);
							if (opClientToken === null) {
								if (this.debugCheck()) {console.log("Initiate Device - operation in progress")};
							}

							this.thingShadows.subscribe();
						}, 2000);
					});

					this.thingShadows.on("close", () => {
						if (this.debugCheck()) {console.log("Initiate Device - close")};
					});

					this.thingShadows.on("reconnect", () => {
						if (this.debugCheck()) {console.log("Initiate Device - reconnect / reregister")};
						this.thingShadows.register(result.devices[0], {});
					});

					this.thingShadows.on("offline", () => {
						if (this.debugCheck()) {console.log("Initiate Device - offline")};
						this.checkOffline();
					});

					/*
					this.thingShadows.on("timeout",(thingName, clientToken) => {
							if (this.debugCheck()) {console.log("Initiate Device - timedout", thingName)};
						}
					);

					this.thingShadows.on("error", error => {
						if (this.debugCheck()) {console.log("Initiate Device - error", error)};
					});

					this.thingShadows.on("message", function(topic, payload) {
						if (this.debugCheck()) {console.log("Initiate Device - message", topic, payload.toString())};
					});
					*/

					this.thingShadows.on( "status",(thingName, stat, clientToken, stateObject) => {
							if (this.debugCheck()) {console.log("Initiate Device - status", thingName, stateObject)};
							const { t } = this.props;

							const {
								modeText,
								color,
								colorLight,
								colorDark,
							} = this.updateMode(
								stateObject.state.reported.mode
							);

							this.activityAni = Animated.timing(
								this.state.colorChange,
								{
									toValue: 50,
									easing: Easing.linear,
									duration: 1000,
								}
							).start(ani => {
								if (ani.finished) {
									this.setState({
										connected: true,
										prevColor: this.state.color,
										prevColorLight: this.state.colorLight,
										prevColorDark: this.state.colorDark,
									});
									this.state.colorChange.setValue(0);
								}
							});

							this.setState({
								desired: {
									...stateObject.state.reported,
								},
								delta: {
									...stateObject.state.delta,
								},
								reported: {
									...stateObject.state.reported,
								},
								metadata: {
									...stateObject.metadata,
								},
								shadowDetails: {
									...stateObject.state.reported,
								}
							}, () => {
								if(Platform.OS !== "web"){
									AsyncStorage.setItem("shadowDetails", JSON.stringify(this.state.reported));
									AsyncStorage.setItem("deviceId", JSON.stringify(this.state.deviceId));
								} else {
									localStorage.setItem("shadowDetails", JSON.stringify(this.state.reported));
									localStorage.setItem("deviceId", JSON.stringify(this.state.deviceId));
								}
								if (this.debugCheck()) {console.log(this.state.shadowDetails);}
							});

							this.changeMode(stateObject.state.reported.mode);
						}
					);

					this.thingShadows.on(
						"foreignStateChange", this._foreignStateChange
					);

					this.thingShadows.on("delta", (thingName, stateObject) => {
						if (this.debugCheck()) {console.log("delta", thingName, stateObject);}

						if (stateObject.state === 7 && this.state.reported.mode === 20) {
							return;
						}

						this.setState({
							delta: {
								...stateObject.state,
							},
						});

						this.checkOffline();
					});

					this.thingShadows.register(
						result.devices[0],
						{},
						function() {
							console.log("register");
						}
					);
				}
			})
			.catch(err => {
				this.setState({
					loading: false,
					modeText: this.props.t("labels.offline"),
				});

				if (err.status === 403 || err.status === 503) {
					console.log("4/503 Refresh Requested");
					autoLogin()
						.then(res => {
							console.log("Refresh Response : ", res);
							this.initDevice();
							return;
						})
						.catch(err => {
							console.error(err.message);
							this.logout();
						});
				}

				if (err.message === "Failed to fetch") {
					console.error(err.message);
					this.logout();
					return;
				}

				if (err.message === "Unauthorized") {
					console.log("Unauthorised - Refresh Requested");
					autoLogin()
						.then(res => {
							console.log("Refresh Response : ", res);
							this.initDevice();
							return;
						})
						.catch(err => {
							console.error(err.message);
							this.logout();
						});
				}
				if (err.message === "Identity token has expired") {
					console.log("Token Expired - Refresh Requested");
					autoLogin()
						.then(res => {
							console.log("Refresh Response : ", res);
							this.initDevice();
							return;
						})
						.catch(err => {
							console.error(err.message);
							this.logout();
						});
				}
			});
	}

	updateMode(mode) {
		if (this.debugCheck()) {console.log("updateMode - Reqested mode : "+mode)}
		clearTimeout(this.autoTimeout);

		return {
			...this.getModeValues(mode),
		};
	}

	changeMode(mode) {
		if (this.debugCheck()) {console.log("changeMode requested - mode : ", mode)};

	 const oldMode = this.state.desired.mode;

		Animated.timing(this.state.colorChange, {
			toValue: 50,
			easing: Easing.linear,
			duration: 1000,
		}).start(ani => {
			if (ani.finished) {
				this.setState({
					prevColor: this.state.color,
					prevColorLight: this.state.colorLight,
					prevColorDark: this.state.colorDark,
				});
				this.state.colorChange.setValue(0);
			}
		});
			this.setState(
			{
				loading: true,
				desired: {
					...this.state.desired,
					mode,
				},
				...this.getModeValues(MODE.UPDATING),
			},
			() => {
				const body = {
					mode,
					mvalue: null,
					online: 1,
				};
				post(`${ControlPanelPostIP}/${this.state.deviceId}`, body)
					.then(res => {
						if (res.status.ok) {
							if (this.debugCheck()) {console.log("Post Success");};
							return res;
						} else {
						throw Error ('Post Request rejected: ${res.status}');
						}
					})
					.then(res => res.json())
					.catch(err => {
						this.setState({
							loading: false,
							desired: {
								...this.state.desired,
								mode: oldMode,
							},
						});
					});
			}
		);

}

	perform() {
		const body = {
			mvalue: this.state.desired.mvalue,
			mode: this.state.desired.mode,
		};
		this.setState({
			loading: true,
		})

		post(`${ControlPanelPostIP}/${this.state.deviceId}`, body)
			.then(res => {
				if (res.status.ok) {
					this.setState({
						loading: false,
						inc: false,
					});
				} else {
					throw Error ('Post Request rejected: ${res.status}');
				}
			})

			.then(res => res.json())

			.catch(err => {
				this.setState({
					loading: false,
					inc: false,
					desired: {
						...this.state.reported,
					},
				});
			})
		}

	decrementValue() {
		if (this.state.loading) { return; }

		if (this.state.connected && (this.state.desired.mode !== MODE.OFF && this.state.desired.mode !== MODE.ROOM)) {
			if (this.debugCheck()) {console.log("decrementValue - Starting Value : ", this.state.desired.mvalue)}
			if (this.state.desired.mvalue - 1 >= this.state.desired.mmin) {
				clearTimeout(this.autoTimeout);
				this.setState({
					desired: {
						...this.state.desired,
						mvalue: this.state.desired.mvalue - 1,
					},
					...this.getModeValues(MODE.UPDATING),
					inc: true,
				});
				if (this.debugCheck()) {console.log("decrementValue - decremented Value : ", this.state.desired.mvalue)}
				this.timer = setTimeout(this.decrementValue, 300);
			}
		}
	}

	incrementValue() {
		if (this.state.loading) {return;}

		if (this.state.connected && (this.state.desired.mode !== MODE.OFF && this.state.desired.mode !== MODE.ROOM)) {
			if (this.debugCheck()) {console.log("incrementValue - Starting Value : ", this.state.desired.mvalue)}
			if (this.state.desired.mvalue + 1 <= this.state.desired.mmax) {
				clearTimeout(this.autoTimeout);
				this.setState({
					desired: {
						...this.state.desired,
						mvalue: this.state.desired.mvalue + 1,
					},
					...this.getModeValues(MODE.UPDATING),
					inc: true,
				});
				if (this.debugCheck()) {console.log("incrementValue - Incremented Value : ", this.state.desired.mvalue)}
				this.timer = setTimeout(this.incrementValue, 300);
			}
		}
	}

	stopTimer() {
		if (this.state.connected && this.state.desired.mode !== MODE.OFF) {
			clearTimeout(this.timer);
			this.perform();
		}
	}

	registerDevice() {
		setTimeout(() => {
			push({ mobile: "Connect", web: "/connect" }, this.props, true);
		}, 1000);
	}

	handleLayout(evt) {
		this.setState({
			width: Dimensions.get("window").width,
			height: Dimensions.get("window").height,
		});
	}

	logout() {
		signout()
			.then(res => {
				reset({ mobile: "Login", web: "/login" }, this.props);
			})
			.catch(err => {
				console.log(err);
			});
	}

	showDialog(isShow) {
		if(Platform.OS !== "web"){
			this.setState({isDialogVisible: isShow});
		}
	}

	toggleShowUnitDetail() {
		this.setState({
			showUnitDetail: !this.state.showUnitDetail
		});

		Animated.timing(
			this.state.colorChange,
			{
				toValue: 50,
				easing: Easing.linear,
				duration: 1000,
			}
		).start(ani => {
			if (ani.finished) {
				this.setState({
					prevColor: this.state.color,
					prevColorLight: this.state.colorLight,
					prevColorDark: this.state.colorDark,
				});
				this.state.colorChange.setValue(0);
			}
		});
	}

	goMore() {
		 this.state.actionContainer.measure((x, y, width, height)=>{
			const nextOffset = this.state.moreButton ? -1 * width : 0;
			Animated.timing(this.state.actionContainerOffset,
				{
					toValue: nextOffset,
					easing: Easing.in(),
					duration: 400,
				}
			).start();
			this.setState({moreButton: false});
		 });
	}

	goBack() {

		if (this.state.showUnitDetail) {this.toggleShowUnitDetail();};

		this.state.actionContainer.measure((x, y, width, height)=>{
			const nextOffset = this.state.moreButton ? -1 * width : 0;
			Animated.timing(this.state.actionContainerOffset,
				{
					toValue: nextOffset,
					easing: Easing.in(),
					duration: 400,
				}
			).start();
			this.setState({moreButton: true});
		 });
	}

	desiredValue() {
		if (this.debugCheck) {console.log("Running desired value - Reported Mode : "+this.state.reported.mode+" Desired Mode : "+this.state.desired.mode)};
		var value = "";
		if (this.state.desired.mode === MODE.OFF ||
			this.state.reported.mode === MODE.AUTO ||
			this.state.desired.mode === MODE.AUTO) {
				value = this.state.reported.kptemp;
			} else if (this.state.desired.mode === MODE.PUMP) {value = "P";
		} else if (this.state.desired.mode === MODE.TIMER_SET ||
							this.state.reported.mode === MODE.TIMER_SET) {value = this.state.desired.mvalue;
		} else if (this.state.reported.mode === MODE.TIMER) {
			if (this.state.reported.timerhour === 0) { value = this.state.reported.timermin;
			} else { value = this.state.reported.timerhour +":"+this.state.reported.timermin;}
		}	else {value = this.state.desired.mvalue;};
		if (this.debugCheck) {console.log("Desired value : ",value)};

		if (value === "undefined" || value === "undefined:undefined") {return ":";} else {return value;};

	}

	aircondValue() {
		if (this.debugCheck) {console.log("Running aircond value - Reported Mode : "+this.state.reported.mode+" Desired Mode : "+this.state.desired.mode)};
		var value = "";
		if (this.state.desired.mode === MODE.OFF ||
			this.state.reported.mode === MODE.AUTO_SET ||
			this.state.desired.mode === MODE.AUTO) { value = this.state.reported.kptemp;
			} else if (this.state.desired.mode === MODE.TIMER_SET ||
								this.state.reported.mode === MODE.TIMER_SET) {value = this.state.desired.mvalue;
			} else if (this.state.reported.mode === MODE.TIMER) {
				if (this.state.reported.timerhour === 0) { value = this.state.reported.timermin;
				} else { value = this.state.reported.timerhour +":"+this.state.reported.timermin; }
		} else if (this.state.reported.mode === MODE.PUMP) {value = "P";
		} else {value = this.state.reported.mvalue;}
		if (this.debugCheck) {console.log("Aircond value : ",value)};
		if (value === "undefined" || value === "undefined:undefined") {return ":";} else {return value;};
	}

	gaugeText() {
		if (this.debugCheck()) {console.log("gaugeText - Requested");}
		var value = '';
		if (this.state.desired.mode === MODE.AUTO || this.state.desired.mode === MODE.AUTO_SET || this.state.desired.mode === MODE.OFF || this.state.reported.mode === MODE.OFF) {
			value = "°C";
			if (this.debugCheck()) {console.log("Gauge Text Supplied : ",value);};
			return value;
		}
		if (this.state.reported.mode === MODE.TIMER || this.state.desired.mode == MODE.TIMER) {
			if (this.state.shadowDetails.timerhour === 0) {
				value = "min";
				if (this.debugCheck()) {console.log("Gauge Text Supplied : ",value);};
				return value;
			} else {
				return " ";
			}
		}
		if (this.state.timerSet && this.state.desired.mvalue === 1) {
			value = "Hr";
			if (this.debugCheck()) {console.log("Gauge Text Supplied : ",value);};
			return value;
		}
		if (this.state.timerSet && this.state.desired.mvalue > 1) {
			value = "Hrs";
			if (this.debugCheck()) {console.log("Gauge Text Supplied : ",value);};
			return value;
		}
		if (this.state.reported.mode === MODE.PUMP || this.state.desired.mode === MODE.PUMP) {
			value = " ";if (this.debugCheck()) {console.log("Gauge Text Supplied : ",value);};
			return value;
		}
	}

	render() {
		const { t } = this.props;

		const color = this.state.colorChange.interpolate({
			inputRange: [0, 50],
			outputRange: [this.state.prevColor, this.state.color],
		});

		const colorLight = this.state.colorChange.interpolate({
			inputRange: [0, 50],
			outputRange: [this.state.prevColorLight, this.state.colorLight],
		});

		const colorDark = this.state.colorChange.interpolate({
			inputRange: [0, 50],
			outputRange: [this.state.prevColorDark, this.state.colorDark],
		});

		const isSafetyWater = this.state.safetyWater;

		let heightVal = null;
		if (Platform.OS !== "web") {
			heightVal = '47.5%';
		}else{
			heightVal = '276px';
		}

		return (
			<View
				onLayout={this.handleLayout}
				style={{
					position: "relative",
					height: "100%",
				}}
			>

				<BackgroundImage
					source={require("assets/bg.fw.jpg")}
					style={[
						styles.shadow,
						styles.background,
						Platform.OS === "web" && this.state.width > 600
							? {
									minWidth: 500,
									maxHeight: 800,
									minHeight: 600,
									width: 600,
									marginLeft: "auto",
									marginRight: "auto",
									marginTop: "auto",
									marginBottom: "auto",
							  }
							: {
									width: this.state.width,
									height: this.state.height,
							  },
					]}
				>

					{this.state.modeText === this.props.t("labels.offline") && (
						<TouchableOpacity
							onPress={this.goRegister}
							style={{
								position: "absolute",
								top: Platform.OS === "web" ? 0 : 40,
								right: 0,
								padding: 5,
								zIndex: 100,
							}}
						>
							<Image
								source={require("assets/black-wifi-icon-hi.png")}
								resizeMode="contain"
								style={{ height: 20, width: 20 }}
							/>
						</TouchableOpacity>
					)}

					{
						(!this.state.showUnitDetail)
						?
							<Animated.View
								style={[
									x.d.flex,
									x.flexDirection.row,
									x.justifyContent.center,
								]}
							>
								<View
									style={[
										x.justifyContent.center,
										x.mr.three,
										this.state.connected &&
										this.state.desired.mode !== MODE.ROOM &&
										this.state.desired.mode !== MODE.OFF &&
										this.state.desired.mode !== MODE.PUMP
											? {}
											: { opacity: 0.2 },
									]}
								>

									<TouchableOpacity
										style={[
											x.alignItems.flexEnd,
											x.justifyContent.center,
											{
												width: "100%",
												height: "50%",
											},
										]}
										onPressIn={this.decrementValue}
										onPressOut={this.stopTimer}
									>
										<View
											style={{
												transform: [{ rotate: "180deg" }],
											}}
										>
											<ArrowUp
												fill="white"
												opacity={1}
												scale={2}
											/>
										</View>
									</TouchableOpacity>
								</View>

								<View style={[x.justifyContent.center]}>
									<Gauge
										connected={this.state.connected}
										operation={this.gaugeText()}
										textColor="black"
										loading={this.state.loading}
										desiredValue={this.desiredValue()}
										aircondValue={this.aircondValue()}
										name={this.state.modeText}
										pulseColor={this.state.colorDark}
									/>
								</View>

								<View
									style={[
										x.justifyContent.center,
										x.ml.three,
										this.state.connected &&
										this.state.desired.mode !== MODE.ROOM &&
										this.state.desired.mode !== MODE.OFF &&
										this.state.desired.mode !== MODE.PUMP
											? {}
											: { opacity: 0.2 },
									]}
								>
									<TouchableOpacity
										style={[
											x.alignItems.flexStart,
											x.justifyContent.center,
											{
												width: "100%",
												height: "50%",
											},
										]}
										onPressIn={this.incrementValue}
										onPressOut={this.stopTimer}
									>
										<View>
											<ArrowUp
												fill="white"
												opacity={1}
												scale={2}
											/>
										</View>
									</TouchableOpacity>
								</View>
							</Animated.View>
						:
							null
					}

					{ (this.state.showUnitDetail)
						?
							(this.state.shadowDetails !== null)
								?
								<View style={[x.justifyContent.center, { height: heightVal }]}>
									<Text style={{ fontSize: 24, color: "white", textAlign: "center" }}>
									{"Unit Details\nSoftware Version : " + this.state.shadowDetails.version + "\n" + "Fan Running Hours : " + this.state.shadowDetails.fanRunTime + "\n" + "Pump Running Hours : " + this.state.shadowDetails.pumpRunTime}
									</Text>
								</View>
							:
								<View style={[x.justifyContent.center, { height: heightVal }]}>
									<Text style={{ fontSize: 24, color: "white", textAlign: "center" }}>
									{"Loading..."}
									</Text>
								</View>
						:
							null
					}

					<SafeAreaView style={[x.d.flex]}>
						<View style={[x.d.flex, styles.buttonContainer]} ref={component => (this.state.actionContainer = component)} renderToHardwareTextureAndroid>
							<Animated.View style={[x.d.flex, x.flexDirection.row, styles.actionContainer, {left: this.state.actionContainerOffset}]}>

								<HomeButton
									connected={this.state.connected}
									color={
										this.state.desired.mode === MODE.AUTO ||
										this.state.desired.mode ===
											MODE.AUTO_SET
											? this.state.colorDark
											: this.state.defaultColor
									}
									onPress={() => this.touchMode(MODE.AUTO)}
								>
									<Auto scale={3} fill="white" />
									<Text
										style={[x.pt.one, { color: "white" }]}
									>
										{t("labels.auto")}
									</Text>
								</HomeButton>

								<HomeButton
									connected={this.state.connected}
									color={
										(this.state.desired.mode === MODE.COOL ||
											this.state.desired.mode === MODE.PUMP)
											? this.state.colorDark
											: this.state.defaultColor
									}
									onPress={() => this.touchMode(MODE.COOL)}
								>

									{ isSafetyWater ? <SafetyWater fill="white" scale={3} opacity={1} /> : <Cool fill="white" scale={3} />}

									<Text
										style={[x.pt.one, { color: "white" }]}
									>
										{ isSafetyWater ? t("labels.safetyWaterOnly") : t("labels.cool") }

									</Text>
								</HomeButton>

								<HomeButton
									connected={this.state.connected}
									color={this.state.defaultColor}
									onPress={this.toggleShowUnitDetail}
								>
								<UnitDetail fill="white" scale={3} />
								<Text style={[x.pt.one, { color: "white" }]}>
									{t("labels.unitDetails")}
								</Text>
								</HomeButton>


								<HomeButton
									connected={this.state.connected}
									color={this.state.defaultColor}
									onPress={this.goUserDetail}
								>
									<View style={[x.ml.two]}>
										<User fill="white" scale={3} />
									</View>
									<Text
										style={[x.pt.one, { color: "white" }]}
									>
										{t("labels.account")}
									</Text>
								</HomeButton>
							</Animated.View>


							<Animated.View style={[x.d.flex, x.flexDirection.row, styles.actionContainer, {left: this.state.actionContainerOffset}]}>

								<HomeButton
									connected={this.state.connected}
									color={
													this.state.desired.mode === MODE.FAN
													? this.state.colorDark
													: this.state.defaultColor
												} onPress={() => this.touchMode(MODE.FAN)}
									>
									<Fan fill="white" scale={3} />
									<Text style={[x.pt.one, { color: "white" }]}>
										{t("labels.fan")}
										</Text>
								</HomeButton>


								<HomeButton
									connected={this.state.connected}
									color={
										this.state.desired.mode === MODE.EXHAUST
										? this.state.colorDark
										: this.state.defaultColor
									}
									onPress={() => this.touchMode(MODE.EXHAUST)}
								>
								<View style={[x.ml.two]}>
								<Exhaust fill="white" scale={3} />
								</View>
								<Text style={[x.pt.one, { color: "white" }]}>
									{t("labels.exhaust")}
								</Text>
								</HomeButton>


								<HomeButton
									connected={this.state.connected}
									color={this.state.defaultColor}
									onPress={this.goDeviceSetting}
								>
									<DeviceSetting fill="white" scale={3} />
									<Text
										style={[x.pt.one, { color: "white" }]}
									>
										{t("Device Setting")}
									</Text>
								</HomeButton>


								<HomeButton
					 				connected={this.state.connected}
									color={this.state.desired.mode === MODE.TIMER_SET ||
													this.state.reported.mode === MODE.TIMER
													? this.state.colorDark
													: this.state.defaultColor
												} onPress={() => this.touchMode(MODE.TIMER_SET)}
								>
								<View style={[x.ml.two]}>
								<Timer fill="white" scale={3} />
								</View>
								<Text style={[x.pt.one, { color: "white" }]}>
								{t("Timer")}
								</Text>
								</HomeButton>
							</Animated.View>


							<View style={[x.d.flex, x.flexDirection.row]}>
								<HomeButton
									connected={this.state.connected}
									color={
										this.state.desired.mode === MODE.OFF
											? this.state.colorDark
											: this.state.defaultColor
									} onPress={() => this.touchMode(MODE.OFF)}
								>
									<View
										style={[
											x.flexDirection.row,
											x.ml.auto,
											x.mr.auto,
											x.mb.three,
											x.alignItems.center,
											x.justifyContent.center,
										]}
									>
										<PowerOff fill="white" scale={3} />
										<Text
											style={[
												x.pl.one,
												{ color: "white" },
											]}
										>
											{t("labels.off")}
										</Text>
									</View>
								</HomeButton>

								<HomeButton
									connected={this.state.connected}
									color={this.state.defaultColor}
									onPress={this.logout}
								>
									<View
										style={[
											x.flexDirection.row,
											x.ml.auto,
											x.mr.auto,
											x.mb.three,
											x.alignItems.center,
											x.justifyContent.center,
										]}
									>
										<Signout fill="white" scale={3} />
										<Text
											style={[
												x.pl.one,
												{ color: "white" },
											]}
										>
											{t("labels.logout")}
										</Text>
									</View>
								</HomeButton>

								{this.state.moreButton  &&
									<HomeButton
										connected={this.state.connected}
										color={this.state.defaultColor}
										onPress={ this.goMore }
									>
										<View
											style={[
												x.flexDirection.row,
												x.ml.auto,
												x.mr.auto,
												x.mb.three,
												x.alignItems.center,
												x.justifyContent.center,
											]}
										>
											<More fill="white" scale={3} />
											<Text
												style={[
													x.pl.one,
													{ color: "white" },
												]}
											>
												{t("labels.more")}
											</Text>
										</View>
									</HomeButton>
								}

								{!this.state.moreButton  &&
									<HomeButton
									connected={this.state.connected}
									color={this.state.defaultColor}
									onPress={ this.goBack }
									>
										<View
											style={[
											x.ml.auto,
											x.mr.auto,
											x.mb.three,
											x.alignItems.center,
											x.justifyContent.center,
											]}
										>
											<Back fill="white" scale={3} />
											<Text style={[x.pl.one,{ color: "white" },]}>
												{t("labels.back")}
											</Text>
										</View>
									</HomeButton>
								}

							</View>
						</View>
					</SafeAreaView>
				</BackgroundImage>
			</View>
		);
	}
}

const styles = StyleSheet.create({
	register: {},
	container: {
		flex: 1,
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: "#ecf0f1",
	},
	app: {
		marginBottom: "20%",
		marginTop: "15%",
	},
	shadow: {
		shadowColor: "#000",
		shadowOffset: {
			width: 0,
			height: 3,
		},
		shadowRadius: 5,
		shadowOpacity: 0.5,
	},
	appHeader: {
		padding: 20,
		height: 100,
	},
	appTitle: {
		fontSize: 16,
		color: "white",
	},
	appIntro: {
		flex: 2,
		fontSize: 30,
		textAlign: "center",
	},
	loginBody: {
		marginTop: 40,
	},
	background: {
		backgroundColor: "rgba(255,255,255,0.1)",
	},
	buttonContainer: {
		overflow: 'hidden'
	},
	actionContainer: {
		width: '200%',
	},
	hiddenContainer: {
		top: window.height,
		bottom: -window.height
	},
	hiddenWebContainer: {
		display: "none",
	}

});

export default translate()(Home);



// WEBPACK FOOTER //
// ./src/views/Home/index.js